import React, { useState } from "react";
import "./GreenPlanStyle.scss";
import AlertBox from "../../Common/Alertbox/AlertBox";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
function GreenPlan() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { planDetails } = location.state || {};
  const selectedLimit = planDetails?.selectedLimit;
  const [open, setOpen] = useState(false);

  const handleAddon = () => {
    setOpen(true);
  };

  const handleSubmit = () => {
    navigate("/personal-information", {
      state: { planDetails },
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 p-3">
          <h3 className="title pt-2 mb-2">{t(planDetails?.coverPlan)}</h3>
          <h5 className="title subHeader p-0 fw-bold py-1 mb-0">{t(selectedLimit?.planName)}</h5>
        </div>
      </div>
      <div className="row p-3"> 
        <div className="col-md-6">
          <div className="plan-card-plan mb-2 shadow p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="plan-info">
                <p className="plan-name">{t("Plan Details")}</p>
              </div>
              <div className="plan-action">
                <p className="plan-price">
                  <span className="price-amount">
                    {selectedLimit?.selectedPlanAmount} OMR
                  </span>
                  {/* <span className="price-amount"> OMR</span> */}
                </p>
              </div>
          </div>
          <hr/>
          {planDetails?.coverPlan == "Individual Medical" && (
            <>
              <p className="plan-desc">
                <span className="me-2">
                  <i class="bi bi-patch-check"></i>
                </span>
                {t("Annual Limit is")} {selectedLimit?.annualLimit} omr
              </p>
              <p className="plan-desc my-4">
                <span className="me-2 ">
                  <i class="bi bi-patch-check"></i>
                </span>
                {t("Op deductible (seprately applied to both PC & DT) is")}{" "}
                {selectedLimit?.opDetectable} OMR
              </p>
              <p className="plan-desc my-4">
                <span className="me-2">
                  <i class="bi bi-patch-check"></i>
                </span>
                {t("PM Co Pay")} {selectedLimit?.coPay}
              </p>
            </>
          )}
          {(planDetails?.coverPlan == "Affordable Health Cover" ||
            planDetails?.coverPlan == "Unified Domestic Worker") && (
            <>
              <p className="plan-desc">
                <span className="me-2">
                  <i class="bi bi-patch-check"></i>
                </span>
                {t("In Patient Coverage")} {selectedLimit?.inPatientCoverage} OMR
              </p>
              <p className="plan-desc my-4">
                <span className="me-2 ">
                  <i class="bi bi-patch-check"></i>
                </span>
                {t("Out Patient Coverage")} {selectedLimit?.outPatientCoverage} OMR
              </p>
              <p className="plan-desc my-4">
                <span className="me-2">
                  <i class="bi bi-patch-check"></i>
                </span>
                {t(selectedLimit?.annualLimit)}
              </p>
            </>
          )}
          <hr />
            <div className="d-flex">
              {/* <button
              type="button"
              onClick={handleAddon}
              className="btn btn-primary me-4"
            >
              {t("Select Life Insurance Addon")}
            </button>  */}
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-primary"
            >
              {t("Confirm Plan")}
            </button>
          </div>
          </div>
        </div> 
      </div>
    </>
  );
}

export default GreenPlan;
